module.exports = __webpack_public_path__ + "media/images/logo-9191bc42b9a555bdfaab9ab8182c0613.png";